<template>
  <header class="smart-header">
    <div class="smart-header__container">
      <NuxtLink to="/" class="smart-header__logo">
        <img
          height="60"
          width="60"
          src="/img/logo/logo-mini.svg"
          alt="logo"
        />
      </NuxtLink>

      <SmartHeaderNav class="smart-header__nav" />
    </div>
  </header>
</template>

<script>
import SmartHeaderNav from './Nav'
export default {
  name: 'AppHeaderSmart',
  components: {
    SmartHeaderNav,
  },
}
</script>

<style lang="scss" scoped src="./style.scss" />
